import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TemplateHeadersService {
  templateList = [{
    templateName: "Case Comments",
    headers: [
      { Name: 'Case Type', type: 'input', key: 'CasetypeDisplayName', colWidth: 'col-sm-2' }
      , { Name: 'Sites', type: 'input', key: 'SiteName', colWidth: 'col-sm-1' }
      , { Name: 'Template Name', type: 'input', key: 'TemplateName', colWidth: 'col-sm-2' }
      , { Name: 'Description', type: 'input', key: 'Description', colWidth: 'col-sm-5' }
      , { Name: 'User', type: 'text', key: 'User', colWidth: 'col-sm-2' },

    ]
  },
  {
    templateName: "Grossing template",
    headers: [
      { Name: 'Case Type', type: 'text', key: 'CasetypeDisplayName', colWidth: 'col-sm-2' }
      , { Name: 'Sites', type: 'input', key: 'SiteName', colWidth: 'col-sm-1' }
      , { Name: 'Template Name', type: 'input', key: 'TemplateName', colWidth: 'col-sm-2' }
      , { Name: 'Description', type: 'input', key: 'Description', colWidth: 'col-sm-4' }
      , { Name: 'Default', type: 'text', key: 'IsDefault', colWidth: 'col-sm-1' }
    ]
  },
  {
    templateName: "Grossing Attributes",
    headers: [
      { Name: 'Name', type: 'text', key: 'Attribute_Name', colWidth: 'col-sm-4' }
      , { Name: 'Configuration Level', type: 'text', key: 'Attribute_Level', colWidth: 'col-sm-6' }
      , { Name: 'Default', type: 'text', key: 'IsDefault', colWidth: 'col-sm-1' }
    ]
  },
  {
    templateName: "Rejection template",
    headers: [
      { Name: 'Template Name', type: 'input', key: 'AttributeName', colWidth: 'col-sm-3' }
      , { Name: 'Description', type: 'input', key: 'AttributeDescription', colWidth: 'col-sm-7' }
    ]
  },
  {
    templateName: "Screening Comments",
    headers: [
      { Name: 'Case Type', type: 'text', key: 'CasetypeDisplayName', colWidth: 'col-sm-2' }
      , { Name: 'Template Name', type: 'input', key: 'TemplateName', colWidth: 'col-sm-3' }
      , { Name: 'Description', type: 'input', key: 'Description', colWidth: 'col-sm-4' }
      , { Name: 'Default', type: 'text', key: 'IsDefault', colWidth: 'col-sm-1' }
    ]
  },
  {
    templateName: "ICD Codes",
    headers: [
       { Name: 'Case Type', type: 'input', key: 'CasetypeDisplayName', colWidth: 'col-sm-3' }
      ,{ Name: 'Sequence', type: 'text', key: 'Sequence', colWidth: 'col-sm-2' }
      , { Name: 'ICD Code', type: 'input', key: 'ICD9Code', colWidth: 'col-sm-2' }
      , { Name: 'Code Name', type: 'input', key: 'ICD9CodeName', colWidth: 'col-sm-4' }

    ]
  },
  {
    templateName: "RevisionNotes",
    headers: [
      { Name: 'Case Type', type: 'text', key: 'CasetypeDisplayName', colWidth: 'col-sm-3' }
      , { Name: 'Template Name', type: 'input', key: 'TemplateName', colWidth: 'col-sm-2' }
      , { Name: 'Description', type: 'input', key: 'Description', colWidth: 'col-sm-5' }
    ]
  },
  {
    templateName: "RevisionReasons",
    headers: [
      { Name: 'Template Name', type: 'input', key: 'TemplateName', colWidth: 'col-sm-3' }
      , { Name: 'Description', type: 'input', key: 'Description', colWidth: 'col-sm-7' }
    ]
  },
  {
    templateName: "AdequacyCodes",
    headers: [
      { Name: 'Case Type', type: 'input', key: 'CasetypeDisplayName', colWidth: 'col-sm-2' }
      , { Name: 'Adequacy Code', type: 'input', key: 'Name', colWidth: 'col-sm-3' }
      , { Name: 'Description', type: 'text', key: 'Description', colWidth: 'col-sm-5' }
    ]
  },
  {
    templateName: "Manage Payers",
    headers: [
      { Name: 'Payer Name', type: 'text', key: 'PayerName', colWidth: 'col-sm-3' }
      , { Name: 'Electronic Payer ID', type: 'input', key: 'ElectronicPayerID', colWidth: 'col-sm-2' }
      , { Name: 'Payer Family', type: 'input', key: 'PayerFamily', colWidth: 'col-sm-2' }
      , { Name: 'Address', type: 'input', key: 'Address', colWidth: 'col-sm-2' }
      , { Name: 'State', type: 'input', key: 'State', colWidth: 'col-sm-2' }
    ]
  },
  {
    templateName: "Custom Fields",
    headers: [
      { Name: 'Field Name', type: 'text', key: 'Attribute', colWidth: 'col-sm-4' }
    ]
  },

  {
    templateName: "L2L Mapping",
    headers: [
      { Name: 'Source Lab', type: 'text', key: 'Sourcelab', colWidth: 'col-sm-2' }
      , { Name: 'Destination Lab', type: 'text', key: 'Destinationlab', colWidth: 'col-sm-2' }
      , { Name: 'Mapping Server', type: 'text', key: 'MappingServer', colWidth: 'col-sm-1' }
      , { Name: 'Mapping DB', type: 'text', key: 'MappingDbName', colWidth: 'col-sm-1' }
      , { Name: 'Destination Lab URL', type: 'text', key: 'LabBUrl', colWidth: 'col-sm-2' }
      , { Name: 'External DB', type: 'text', key: 'IsExternalDb', colWidth: 'col-sm-1' }
      , { Name: 'Send Out Lab', type: 'text', key: 'IsSendoutLab', colWidth: 'col-sm-2' }
    ]
  },
  {
    templateName: "MicroscopicCodes",
    headers: [
      { Name: 'Case Type', type: 'input', key: 'CasetypeDisplayName', colWidth: 'col-sm-2' }
      , { Name: 'Microscopic Note', type: 'input', key: 'Name', colWidth: 'col-sm-3' }
      , { Name: 'Description', type: 'text', key: 'Description', colWidth: 'col-sm-5' }
    ]
  },
  {
    templateName: "DeletionReasons",
    headers: [
      { Name: 'Template Name', type: 'input', key: 'TemplateName', colWidth: 'col-sm-3' }
      , { Name: 'Description', type: 'input', key: 'Description', colWidth: 'col-sm-7' }
    ]
  },
  {
    templateName: "Categories",
    headers: [
      { Name: 'Category Type', type: 'input', key: 'CategoryTypeDisplayName', colWidth: 'col-sm-3' }
      , { Name: 'Category Name', type: 'input', key: 'CategoryName', colWidth: 'col-sm-7' }
    ]
  },
  {
    templateName: "DiagnosisReferences",
    headers: [
      { Name: 'Case Type', type: 'input', key: 'CasetypeDisplayName', colWidth: 'col-sm-3' },
      { Name: 'Template Name', type: 'input', key: 'TemplateName', colWidth: 'col-sm-3' },
      { Name: 'Description', type: 'input', key: 'Description', colWidth: 'col-sm-4' }
    ]
  },
  {
    templateName: "CustomAbbreviations",
    headers: [
      { Name: 'Case Type', type: 'input', key: 'CasetypeDisplayName', colWidth: 'col-sm-3' },
      { Name: 'Abbreviation', type: 'input', key: 'Abbreviation', colWidth: 'col-sm-3' },
      { Name: 'Phrase', type: 'input', key: 'Phrase', colWidth: 'col-sm-4' }
    ]
  },
  {
    templateName: "UserDefaultRoles",
    headers: [
      { Name: 'Email', type: 'input', key: 'UserEmail', colWidth: 'col-sm-3' }
      , { Name: 'Role Name', type: 'input', key: 'RoleName', colWidth: 'col-sm-3' }
      , { Name: 'Deployment', type: 'input', key: 'DeploymentKey', colWidth: 'col-sm-2' }
      , { Name: 'Entity', type: 'input', key: 'Entity', colWidth: 'col-sm-2' }
    ]
  },
  {
    templateName: "SequesterReasons",
    headers: [
      { Name: 'Template Name', type: 'input', key: 'TemplateName', colWidth: 'col-sm-3' }
      , { Name: 'Description', type: 'input', key: 'Description', colWidth: 'col-sm-7' }
    ]
  },
  {
    templateName: "Correlation Templates",
    headers: [
      { Name: 'Case Type', type: 'text', key: 'CasetypeDisplayName', colWidth: 'col-sm-3' }
      , { Name: 'Name', type: 'input', key: 'AttributeValue', colWidth: 'col-sm-3' }
      , { Name: 'Summary', type: 'input', key: 'AttributeDescription', colWidth: 'col-sm-4' }
      // , { Name: 'Default', type: 'text', key: 'IsDefault', colWidth: 'col-sm-1' }
    ]
  },
  {
    templateName: "Tube Type Templates",
    headers: [
      { Name: 'Case Type', type: 'text', key: 'CasetypeDisplayName', colWidth: 'col-sm-3' }
      , { Name: 'Name', type: 'input', key: 'AttributeValue', colWidth: 'col-sm-3' }
      , { Name: 'Summary', type: 'input', key: 'AttributeDescription', colWidth: 'col-sm-4' }
      // , { Name: 'Default', type: 'text', key: 'IsDefault', colWidth: 'col-sm-1' }
    ]
  },
  {
    templateName: "Nomenclature Templates",
    headers: [
      { Name: 'Case Type', type: 'text', key: 'CasetypeDisplayName', colWidth: 'col-sm-3' }
      , { Name: 'Name', type: 'input', key: 'TemplateName', colWidth: 'col-sm-3' }
      , { Name: 'Description', type: 'input', key: 'Description', colWidth: 'col-sm-4' }
    ]
  },
  {
    templateName: "AutoAssignmentRule-path",
    headers: [
      { Name: 'Pathologist', type: 'input', key: 'Name', colWidth: 'col-sm-2' }
      , { Name: 'Ordering Facility', type: 'input', key: 'OrderingFacility', colWidth: 'col-sm-2' }
      , { Name: 'Ordering Physician', type: 'input', key: 'OrderingPhysician', colWidth: 'col-sm-2' }
      , { Name: 'Casetype', type: 'input', key: 'CaseType', colWidth: 'col-sm-1' }
      , { Name: 'Effective Date', type: 'input', key: 'EffectiveDate', colWidth: 'col-sm-2' }
      , { Name: 'Expiry Date', type: 'input', key: 'DisplayExpiryDate', colWidth: 'col-sm-2' }
    ]
  },
  {
    templateName: "AutoAssignmentRule-cyto",
    headers: [
      { Name: 'Cytotechnologist', type: 'input', key: 'Name', colWidth: 'col-sm-2' }
      , { Name: 'Ordering Facility', type: 'input', key: 'OrderingFacility', colWidth: 'col-sm-2' }
      , { Name: 'Ordering Physician', type: 'input', key: 'OrderingPhysician', colWidth: 'col-sm-2' }
      , { Name: 'Casetype', type: 'input', key: 'CaseType', colWidth: 'col-sm-1' }
      , { Name: 'Effective Date', type: 'input', key: 'EffectiveDate', colWidth: 'col-sm-2' }
      , { Name: 'Expiry Date', type: 'input', key: 'DisplayExpiryDate', colWidth: 'col-sm-2' }
    ]
  },
  {
    templateName: "AutoAssignmentRule-externalOrg",
    headers: [
      { Name: 'Ordering Facility', type: 'input', key: 'OrderingFacility', colWidth: 'col-sm-2' }
      , { Name: 'Ordering Physician', type: 'input', key: 'OrderingPhysician', colWidth: 'col-sm-2' }
      , { Name: 'Casetype', type: 'input', key: 'CaseType', colWidth: 'col-sm-1' }
      , { Name: 'Effective Date', type: 'input', key: 'EffectiveDate', colWidth: 'col-sm-2' }
      , { Name: 'Expiry Date', type: 'input', key: 'DisplayExpiryDate', colWidth: 'col-sm-2' }
    ]
  },
  {
    templateName: "Disclaimers",
    headers: [
      { Name: 'Disclaimer', type: 'input', key: 'Disclaimer', colWidth: 'col-sm-2' }
      , { Name: 'Type', type: 'input', key: 'Type', colWidth: 'col-sm-1' }
      , { Name: 'Created By', type: 'input', key: 'createdby', colWidth: 'col-sm-2' }
      , { Name: 'Created Date', type: 'input', key: 'createddate', colWidth: 'col-sm-2' }
      , { Name: 'Modified By', type: 'input', key: 'modifiedby', colWidth: 'col-sm-2' }
      , { Name: 'Modified Date', type: 'input', key: 'modifieddate', colWidth: 'col-sm-2' }

    ]
  },
  {
    templateName: "Sendout Reasons",
    headers: [
      { Name: 'Template Name', type: 'input', key: 'TemplateName', colWidth: 'col-sm-4' }
      , { Name: 'Description', type: 'input', key: 'Description', colWidth: 'col-sm-6' }
    ]
  },

  // workgroup
  {
    templateName: "Workgroups",
    headers: [
      { Name: 'Department Name', type: 'input', key: 'departmentName', colWidth: 'col-sm-5' }
      , { Name: 'Worklists', type: 'input', key: 'customWorklist', colWidth: 'col-sm-5' }
    ]
  },

  {
    templateName: "Report Signatories",
    headers: [
      { Name: 'Entity Type', type: 'input', key: 'EntityType', colWidth: 'col-sm-3' }
      , { Name: 'Entity Name', type: 'input', key: 'EntityName', colWidth: 'col-sm-4' }
      , { Name: 'User Name', type: 'input', key: 'UserName', colWidth: 'col-sm-3' }
    ]
  },
  {
    templateName: "Sites",
    headers: [
      { Name: "Case Type", type: "text", key: "CasetypeDisplayName", colWidth: "col-sm-2" },
      { Name: 'Body Site', type: 'input', key: 'SubSite', colWidth: 'col-sm-5' }
      // { Name: 'Site Order', type: 'input', key: 'SiteOrder', colWidth: 'col-sm-4' }
    ]
  },
  {
    templateName: "Extraction Procedures",
    headers: [
      { Name: 'Name', type: 'input', key: 'ExtnProcedureName', colWidth: 'col-sm-8' }
      // ,{ Name: 'Sequence', type: 'text', key: 'Sequence', colWidth: 'col-sm-3' }
      , { Name: 'Default', type: 'text', key: 'IsDefault', colWidth: 'col-sm-1' }
    ]
  },
  {
    templateName: "Extraction Procedures Lab",
    headers: [
      { Name: 'Case Type', type: 'text', key: 'CasetypeDisplayName', colWidth: 'col-sm-3' },
      { Name: 'Name', type: 'input', key: 'ExtnProcedureName', colWidth: 'col-sm-6' }
      // ,{ Name: 'Sequence', type: 'text', key: 'Sequence', colWidth: 'col-sm-3' }

      , { Name: 'Default', type: 'text', key: 'IsDefault', colWidth: 'col-sm-1' }
    ]
  },
  {
    templateName: "Medications",
    headers: [
      { Name: 'Medication Code', type: 'input', key: 'MedicationCode', colWidth: 'col-sm-3' }
      , { Name: 'Medication Brand', type: 'input', key: 'MedicationBrand', colWidth: 'col-sm-3' }
      , { Name: 'Medication Description', type: 'input', key: 'MedicationDescription', colWidth: 'col-sm-4' }
    ]
  },
  {
    templateName: "Observation & Quantitation Templates",
    headers: [
      { Name: 'Name', type: 'input', key: 'templateName', colWidth: 'col-sm-3' }
      , { Name: 'Description', type: 'input', key: 'templateDescription', colWidth: 'col-sm-7' }
    ]
  },
  {
    templateName: "Clinical Information",
    headers: [
      { Name: 'Name', type: 'input', key: 'Attribute_Name', colWidth: 'col-sm-3' }
      , { Name: 'Description', type: 'input', key: 'Attribute_Description', colWidth: 'col-sm-7' }
    ]
  },
  {
    templateName: "Cassette Templates",
    headers: [
      { Name: 'Case Type', type: 'text', key: 'CasetypeDisplayName', colWidth: 'col-sm-2' }
      , { Name: 'Template Name', type: 'input', key: 'TemplateName', colWidth: 'col-sm-3' }
      , { Name: 'Description', type: 'input', key: 'Description', colWidth: 'col-sm-4' }
      // , { Name: 'Default', type: 'text', key: 'IsDefault', colWidth: 'col-sm-1' }
    ]
  },
  {
    templateName: "Worklists",
    headers: [
      { Name: 'Role', type: 'input', key: 'Role', colWidth: 'col-sm-2' },
      { Name: 'Tab Name', type: 'input', key: 'TabDisplayName', colWidth: 'col-sm-2' },
      { Name: 'Worklist', type: 'input', key: 'DisplayName', colWidth: 'col-sm-2' },
      { Name: 'Description', type: 'input', key: 'Description', colWidth: 'col-sm-3' },
      { Name: 'Default', type: 'input', key: 'IsDefault', colWidth: 'col-sm-1' }
    ]
  },
  {
    templateName: "Hot Keys",
    headers: [
      { Name: 'Display Name', type: 'input', key: 'HotKeyDisplayName', colWidth: 'col-sm-2' }
      , { Name: 'Case Type', type: 'input', key: 'CaseType', colWidth: 'col-sm-2' }
      , { Name: 'Adequacy Code', type: 'input', key: 'AdequacyCode', colWidth: 'col-sm-2' }
      , { Name: 'Diagnosis Code', type: 'input', key: 'DiagnosisCode', colWidth: 'col-sm-2' }
      , { Name: 'User Name(Role)', type: 'input', key: 'UserName', colWidth: 'col-sm-2' }
    ]
  },
  {
    templateName: "Screening Types PAP",
    headers: [
        { Name: 'Collection Method', type: 'input', key: 'AttributeName', colWidth: 'col-sm-2' }
      , { Name: 'Procedure Name', type: 'input', key: 'Procedure', colWidth: 'col-sm-2' }
     , { Name: 'CPTCodes', type: 'input', key: 'CPTCodes', colWidth: 'col-sm-2' }
     , { Name: 'Default', type: 'text', key: 'IsDefault', colWidth: 'col-sm-1' }
    ]
  },
  {
    templateName: "Screening Types",
    headers: [
       { Name: 'Procedure Name', type: 'input', key: 'Procedure', colWidth: 'col-sm-2' }
     , { Name: 'CPTCodes', type: 'input', key: 'CPTCodes', colWidth: 'col-sm-2' }
     , { Name: 'Default', type: 'text', key: 'IsDefault', colWidth: 'col-sm-1' }
    ]
  },
  {
    templateName: "Manage Configurations",
    headers: [
      { Name: 'Flag Name', type: 'input', key: 'refConfigName', colWidth: 'col-sm-2' }
      , { Name: 'Description', type: 'input', key: 'description', colWidth: 'col-sm-2' }
      , { Name: 'Category', type: 'input', key: 'category', colWidth: 'col-sm-2' }
      , { Name: 'Menu', type: 'input', key: 'featureNames', colWidth: 'col-sm-2' }
      , { Name: 'Excluded Deployments', type: 'input', key: 'deployment', colWidth: 'col-sm-2' }
      , { Name: 'refconfigvalidvalues', type: 'input', key: 'refconfigvalidvalues', colWidth: 'hidden' }
      // , { Name: 'Menu', type: 'input', key: 'featureName', colWidth: 'col-sm-2' }
    ]
  },
  {
      templateName: "Offline Process",
      headers: [
        { Name: 'Deployment', type: 'input', key: 'DeploymentKey', colWidth: 'col-sm-1' }
        , { Name: 'Group Name', type: 'input', key: 'GroupName', colWidth: 'col-sm-2' }
        , { Name: 'Feature', type: 'input', key: 'FeatureName', colWidth: 'col-sm-1' }
        , { Name: 'Date', type: 'input', key: 'StartDateTime', colWidth: 'col-sm-2' }
        , { Name: 'JobStatus', type: 'input', key: 'jobStatus', colWidth: 'col-sm-1' }
        , { Name: 'Reason', type: 'input', key: 'ErrorReason', colWidth: 'col-sm-3' }
        , { Name: 'id', type: 'input', key: 'AzurefileId', colWidth: 'hidden' }
        , { Name: 'User', type: 'input', key: 'username', colWidth: 'col-sm-1' }
      ]
    }
,
  {
    templateName: "VitalDesktop",
    headers: [
      { Name: 'VitalDesktop Identifier', type: 'input', key: 'VD_Identifier', colWidth: 'col-sm-3' }
      , { Name: 'VitalAxis URL', type: 'input', key: 'VitalAxis_URL', colWidth: 'col-sm-3' }
      , { Name: 'VitalAxis Data URL', type: 'input', key: 'VitalAxisDataURL', colWidth: 'col-sm-3' }
    ]
  },
  {
    templateName: "Standing Instructions",
    headers: [
      { Name: 'Priority', type: 'input', key: 'Priority', colWidth: 'col-sm-1' }
      , { Name: 'Instructions', type: 'input', key: 'Instruction', colWidth: 'col-sm-5' }
      , { Name: 'Start Date', type: 'input', key: 'StartDate', colWidth: 'col-sm-2' }
      , { Name: 'Expiry Date', type: 'input', key: 'ExpirationDate', colWidth: 'col-sm-2' }
    ]
  },
  {
    templateName: "Tests",
    headers: [
      { Name: 'Name', type: 'input', key: 'TestName', colWidth: 'col-sm-2', class:'content-color' }
      , { Name: 'Code', type: 'input', key: 'Code', colWidth: 'col-sm-2' }
      , { Name: 'Short Name', type: 'input', key: 'ShortName', colWidth: 'col-sm-2' }
      , { Name: 'Test Count', type: 'input', key: 'TestCount', colWidth: 'col-sm-2' }
      , { Name: 'Order Code Type', type: 'input', key: 'OrderCodeType', colWidth: 'col-sm-2' }
    ]
  },
  {
    templateName: "View Claims",
    headers: [
      { Name: 'Claim #', type: 'input', key: 'claimnumber', colWidth: 'col-sm-1' }
      , { Name: 'Patient Name', type: 'input', key: 'PatientName', colWidth: 'col-sm-1' }
      , { Name: 'Service Date', type: 'input', key: 'ServiceDate', colWidth: 'col-sm-1' }
      , { Name: 'Payer Name', type: 'input', key: 'payername', colWidth: 'col-sm-1' }
      , { Name: '$ Claimed', type: 'input', key: 'Claimed', colWidth: 'col-sm-1' }
      , { Name: '$ Paid', type: 'input', key: 'Paid', colWidth: 'col-sm-1' }
      , { Name: 'Assignee', type: 'input', key: 'Assignee', colWidth: 'col-sm-1' }
      , { Name: 'Demography Status', type: 'input', key: 'DemographyStatus', colWidth: 'col-sm-1' }
      , { Name: 'SubState', type: 'input', key: 'SubState', colWidth: 'col-sm-1' }
      , { Name: 'Age', type: 'input', key: 'Age', colWidth: 'col-sm-1' }
      , { Name: 'Last Updated On', type: 'input', key: 'LastUpdatedOn', colWidth: 'col-sm-1' }
      // , { Name: 'Last Notes', type: 'input', key: 'LastNotes', colWidth: 'col-sm-1' }
    ]
  },
  {
    templateName: "Rescreening Rules",
    headers: [
      { Name: 'User', type: 'input', key: 'user', colWidth: 'col-sm-2'}
      , { Name: 'Role', type: 'input', key: 'role', colWidth: 'col-sm-2' }
      , { Name: 'Percentage(%)', type: 'input', key: 'percentage', colWidth: 'col-sm-2' }
      , { Name: 'Effective Date', type: 'input', key: 'effectivedate', colWidth: 'col-sm-2' }
      , { Name: 'Expiration Date', type: 'input', key: 'expirationdate', colWidth: 'col-sm-2' }
    ]
  },
  {
    templateName: "Pathologist QA Rules",
    headers: [
      { Name: 'User', type: 'input', key: 'user', colWidth: 'col-sm-2'}
      , { Name: 'Role', type: 'input', key: 'role', colWidth: 'col-sm-2' }
      , { Name: 'Percentage(%)', type: 'input', key: 'percentage', colWidth: 'col-sm-2' }
      , { Name: 'Effective Date', type: 'input', key: 'effectivedate', colWidth: 'col-sm-2' }
      , { Name: 'Expiration Date', type: 'input', key: 'expirationdate', colWidth: 'col-sm-2' }
    ]
  },
  {
    templateName: "QAQC Audits",
    headers: [
      { Name: 'Modified Field', type: 'input', key: 'modifiedfield', colWidth: 'col-sm-2'}
      , { Name: 'Previous Value', type: 'input', key: 'previousvalue', colWidth: 'col-sm-2' }
      , { Name: 'Modified Value', type: 'input', key: 'modifiedvalue', colWidth: 'col-sm-2' }
      , { Name: 'Modified By', type: 'input', key: 'modifiedby', colWidth: 'col-sm-2' }
      , { Name: 'Modified On', type: 'input', key: 'modifieddate', colWidth: 'col-sm-2' }
    ]
  },
  {
    templateName: "Pathologist QA Results",
    headers: [
      { Name: 'User Name', type: 'input', key: 'FormattedDisplayName', colWidth: 'col-sm-2'}
      , { Name: 'Role', type: 'input', key: 'rolename', colWidth: 'col-sm-6' }
      , { Name: 'View', type: 'input', key: 'AllowViewReviewResults', colWidth: 'col-sm-1 mx-2 p-0' }
      , { Name: 'Add', type: 'input', key: 'AllowAddReviewResults', colWidth: 'col-sm-1 mx-2 p-0' }
      , { Name: 'Edit', type: 'input', key: 'AllowEditReviewResults', colWidth: 'col-sm-1 mx-2 p-0' }
      , { Name: 'Delete', type: 'input', key: 'AllowDeleteReviewResults', colWidth: 'col-sm-1 p-0' }
    ]
  },
  {
    templateName: "Delete Group",
    headers: [
      { Name: 'Test Lab Account', type: 'input', key: 'LabAccountName', colWidth: 'col-sm-4' }
      , { Name: 'Account Name', type: 'input', key: 'AccountName', colWidth: 'col-sm-4' }
      , { Name: 'Associated Account Name', type: 'input', key: 'AssociatedToLabAccountName', colWidth: 'col-sm-3' }
    ]
  },
  {
    templateName: "Delete Group 1",
    headers: [
      { Name: 'Test Lab Account', type: 'input', key: 'LabAccountName', colWidth: 'col-sm-4' }
      , { Name: 'User Name(UserID)', type: 'input', key: 'DisplayName', colWidth: 'col-sm-4' }
      , { Name: 'Associated Account Name', type: 'input', key: 'AssociatedToLabAccountName', colWidth: 'col-sm-3' }
    ]
  },
  {
    templateName: "Delete Group 2",
    headers: [
      { Name: 'Test Lab Account', type: 'input', key: 'LabAccountName', colWidth: 'col-sm-4' }
      , { Name: 'Associated Account Name', type: 'input', key: 'AccountName', colWidth: 'col-sm-4' }
      , { Name: 'Association Type', type: 'input', key: 'associationtype', colWidth: 'col-sm-3' }
    ]
  },
  {
    templateName: "AOES",
     headers: [
      { Name: 'Question Code', type: 'text', key: 'QuestionCode', colWidth: 'col-sm-2' }
      , { Name: 'Question', type: 'input', key: 'Question', colWidth: 'col-sm-2' }
      , { Name: 'Type', type: 'input', key: 'Type', colWidth: 'col-sm-2' }
      , { Name: 'Mandatory', type: 'text', key: 'Mandatory', colWidth: 'col-sm-2' }
      , { Name: 'Status', type: 'text', key: 'Status', colWidth: 'col-sm-2' }
     ]
  },
  {
    templateName: "ALR",
    headers: [
        { Name: 'Rule Name', type: 'input', key: 'RuleName', colWidth: 'col-sm-2', class:'content-color' }
      , { Name: 'Condition', type: 'input', key: 'ALRRuleConditionExpression', colWidth: 'col-sm-4' }
      , { Name: 'Effective Date', type: 'input', key: 'EffectiveDate', colWidth: 'col-sm-2' }
      , { Name: 'Expiry Date', type: 'input', key: 'ExpiryDate', colWidth: 'col-sm-2' }
    ]
  },
  {
    templateName: "Associations Panel",
     headers: [
       { Name: 'Test Code', type: 'input', key: 'TestCode', colWidth: 'col-sm-2' }
      , { Name: 'Test Name', type: 'input', key: 'TestCodeName', colWidth: 'col-sm-3' }
      , { Name: 'Report Group', type: 'text', key: 'DisplayHeader', colWidth: 'col-sm-4' }
    ]
  },
  {
    templateName: "Associations Test",
     headers: [
       { Name: 'Result Code', type: 'input', key: 'ResultCode', colWidth: 'col-sm-3' }
      , { Name: 'Result Code Name', type: 'input', key: 'ResultCodeName', colWidth: 'col-sm-6' }
    ]
  },
  {
    templateName: "Remote Location",
    headers: [
        { Name: 'Location Name', type: 'input', key: 'remotelocationname', colWidth: 'col-sm-2' }
      , { Name: 'Display Name', type: 'input', key: 'reportdisplayname', colWidth: 'col-sm-2' }
      , { Name: 'Location Code', type: 'input', key: 'remotelocationcode', colWidth: 'col-sm-2' }
      , { Name: 'Address', type: 'input', key: 'address', colWidth: 'col-sm-2' }
      , { Name: 'Phone Number', type: 'input', key: 'phone', colWidth: 'col-sm-2' }
    ]
  },
  {
    templateName: "Reading Location",
    headers: [
        { Name: 'Location Name', type: 'input', key: 'accountname', colWidth: 'col-sm-2' }
      , { Name: 'Display Name', type: 'input', key: 'displayname', colWidth: 'col-sm-2' }
      , { Name: 'Location Code', type: 'input', key: 'accountcode', colWidth: 'col-sm-2' }
      , { Name: 'Address', type: 'input', key: 'address', colWidth: 'col-sm-2' }
      , { Name: 'Phone Number', type: 'input', key: 'phone', colWidth: 'col-sm-2' }
    ]
  },
  {
    templateName: "Result Value",
    headers: [
        { Name: 'Text', type: 'input', key: 'QualifiedName', colWidth: 'col-sm-4' },
        { Name: 'Replace Value', type: 'input', key: 'Value', colWidth: 'col-sm-4' }
    ]
  },
  {
    templateName: "Messages",
    headers: [
        { Name: 'Template Name', type: 'input', key: 'TemplateName', colWidth: 'col-sm-2' },
        { Name: 'Message', type: 'input', key: 'MessageTemplate', colWidth: 'col-sm-2' },
        { Name: 'Apply For', type: 'input', key: 'Context', colWidth: 'col-sm-2' },
        { Name: 'Default', type: 'input', key: 'IsDefault', colWidth: 'col-sm-1' },
        { Name: 'Status', type: 'text', key: 'Status', colWidth: 'col-sm-2' }


    ]
  },
  {
    templateName: "Drugs",
    headers: [
      { Name: 'Drug Name', type: 'text', key: 'DrugName', colWidth: 'col-sm-4' }
      , { Name: 'Drug Class', type: 'input', key: 'DrugClass', colWidth: 'col-sm-3' }
      , { Name: 'Route', type: 'input', key: 'Route', colWidth: 'col-sm-2' }
    ]
  },
  {
    templateName: "Organism",
    headers: [
      { Name: 'Family', type: 'text', key: 'PathogenFamily', colWidth: 'col-sm-2' }
      , { Name: 'Name', type: 'input', key: 'PathogenName', colWidth: 'col-sm-3' }
      , { Name: 'Gram Stain', type: 'input', key: 'GramStain', colWidth: 'col-sm-2' }
      , { Name: 'Type', type: 'text', key: 'PathogenType', colWidth: 'col-sm-2' }
      , { Name: 'Aspiration Method', type: 'input', key: 'AspirationMethod', colWidth: 'col-sm-2' }
    ]
  },
  {
    templateName: "Instruments",
     headers: [
      { Name: 'Instrument Code', type: 'input', key: 'InstrumentCode', colWidth: 'col-sm-2' }
      , { Name: 'Instrument', type: 'input', key: 'Instrument', colWidth: 'col-sm-2' }
      , { Name: 'Status', type: 'input', key: 'Status', colWidth: 'col-sm-2' }
     ]
  },
  {
    templateName: "Instrument Order Code Mapper",
     headers: [
      { Name: 'Order Code', type: 'input', key: 'OrderCode', colWidth: 'col-sm-2' }
      , { Name: 'Display Name', type: 'input', key: 'DisplayName', colWidth: 'col-sm-2' }
      , { Name: 'Send to Instrument', type: 'input', key: 'SendToDevice', colWidth: 'col-sm-3' }
     ]
  },
  {
    templateName: "Requisition Profiles",
    headers: [
      // { Name: 'Requisition Profile Name', type: 'input', key: 'DisplayName', colWidth: 'col-sm-2' },
      { Name: 'Organization', type: 'input', key: 'OrganizationName', colWidth: 'col-sm-3' },
      { Name: 'Locations', type: 'input', key: 'AccountName', colWidth: 'col-sm-2' },
      { Name: 'Physician', type: 'input', key: 'FormattedDisplayName', colWidth: 'col-sm-2' },
      { Name: 'Test/Panel', type: 'input', key: 'OrderCodeNames', colWidth: 'col-sm-2' },
      //{ Name: 'ReqProfileID', type: 'input', key: 'RequisitionProfileID', colWidth: 'col-sm-2' }
    ]
  },
  {
    templateName: "SendOutLabs",
     headers: [
      { Name: 'Code', type: 'input', key: 'InstrumentCode', colWidth: 'col-sm-2' }
      , { Name: 'Sendout Labs', type: 'input', key: 'Instrument', colWidth: 'col-sm-2' }
      , { Name: 'Status', type: 'input', key: 'Status', colWidth: 'col-sm-2' }
     ]
  },
  {
    templateName: "Frozen Location",
    headers: [
        { Name: 'Location Name', type: 'input', key: 'accountname', colWidth: 'col-sm-2' }
      , { Name: 'Display Name', type: 'input', key: 'displayname', colWidth: 'col-sm-2' }
      , { Name: 'Location Code', type: 'input', key: 'accountcode', colWidth: 'col-sm-2' }
      , { Name: 'Address', type: 'input', key: 'address', colWidth: 'col-sm-2' }
      , { Name: 'Phone Number', type: 'input', key: 'phone', colWidth: 'col-sm-2' }
    ]
  },
  {
    templateName: "Intraoperative Templates",
    headers: [
      { Name: 'Case Type', type: 'input', key: 'CasetypeDisplayName', colWidth: 'col-sm-2' }
      , { Name: 'Sites', type: 'input', key: 'SiteName', colWidth: 'col-sm-1' }
      , { Name: 'Template Name', type: 'input', key: 'TemplateName', colWidth: 'col-sm-2' }
      , { Name: 'Description', type: 'input', key: 'Description', colWidth: 'col-sm-5' }
    ]
  }
  ]
  constructor() { }
}
